<template>
    <div class="user_jf_pop" v-loading="loading">
        <el-dialog title="邀请赚积分" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
              <div class="lefts">
                <div class="titles">我的邀请码</div>
                <div class="title_coed">wnvQ7o9e</div>
                <div class="code_btns">复制邀请码</div>
                <div class="erm_text1">邀请二维码</div>
                <div class="erm_imgs">
                    
                </div>
                <div class="erm_text2">扫一扫</div>
              </div>
              <div class="lefts">
                <div class="titles">邀请链接</div>
                <div class="title_coed">http://www.quanshengboda.com</div>
                <div class="code_btns">复制邀请码</div>
                <div class="erm_text1">分享海报</div>
                <div class="erm_imgs">
                    
                </div>
                <div class="erm_text2">下载</div>
              </div>
                
            </div>
        </el-dialog>

       
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
          
            
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
       
        handle_open(){
            this.dialogVisible=true
        }



    },

}
</script>
<style scoped lang="less">
.user_jf_pop {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 791px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    .lefts{
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 43px;
                        }
                        .title_coed{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 10px;
                        }
                        .code_btns{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                            margin-bottom: 40px;
                        }
                        .erm_text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-bottom: 23px;
                        }
                        .erm_imgs{
                            width: 87px;
                            height: 87px;
                            background: #666666;
                            border-radius: 0px 0px 0px 0px;
                        }
                        .erm_text2{
                            width: 87px;
                            text-align: center;
                            margin-top: 11px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }
               
            }
        }
    }
}
</style>